'use client';

import { ArrowLeftOutlined } from '@ant-design/icons';
import { useTranslation } from 'next-i18next/pages';
import { FormProvider, useForm } from 'react-hook-form';

import { Button } from '@/components/atoms/Button';
import { TextField } from '@/components/molecules/FormFields/TextField';
import { getBrowserApiBaseURL } from '@/lib/axiosConfig';

import styles from '../LoginForm.module.css';

type SSOLoginFormData = {
  companyEmail: string;
};

export function SSOLoginForm({ setMode }: { setMode: (mode: 'password' | 'sso') => void }) {
  const { t } = useTranslation('login');

  const form = useForm<SSOLoginFormData>({
    defaultValues: {
      companyEmail: '',
    },
    mode: 'onChange',
  });

  const { handleSubmit } = form;

  const onSubmit = ({ companyEmail }: SSOLoginFormData) => {
    const backend = getBrowserApiBaseURL();
    const url = `${backend}saml_login?email=${encodeURIComponent(companyEmail)}`;

    window.location.assign(url);
  };

  return (
    <FormProvider {...form}>
      <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
        <TextField
          placeholder="example@email.com"
          autocomplete="email"
          name="companyEmail"
          label={t('form.email.label')}
          type="text"
          rules={{
            required: t('form.email.required'),
          }}
        />

        <Button className="full" type="submit">
          {t('form.actions.continue')}
        </Button>

        <Button iconLeft={<ArrowLeftOutlined />} onClick={() => setMode('password')} variant="outlined" type="button">
          {t('form.actions.back')}
        </Button>
      </form>
    </FormProvider>
  );
}
